import { connectSeriesPage } from '../containers/series/connectSeriesPage';
import { SeriesPage } from '../containers/series/SeriesPage';

export default connectSeriesPage(SeriesPage);
